export { VpPopover } from './VpPopover';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpPopover/index.js